import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SubportfoliosComponent } from './subportfolios.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: SubportfoliosComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubportfoliosRoutingModule { }
